<template>
	<credit-card-modal-magensa
		v-if="isMagensa"
		v-on="$listeners"
		v-bind="$props"
	/>
</template>

<script>
import CreditCardModalMagensa from './CreditCardModalMagensa'
import { PAYMENT_PROVIDER } from '@/constants'

import { mapActions, mapGetters } from 'vuex'

export default {
	name: 'CreditCardModal',

	mixins: [],

	props: {
		amount: {
			type: Number,
			required: true
		},
		isPickUp: {
			type: Boolean,
			default: false
		},
		isTicketing: {
			type: Boolean,
			default: false
		},
		orderId: {
			type: String,
			default: ''
		},
		withoutHeader: {
			type: Boolean,
			default: false
		},
		formBackgroundColor: {
			type: String,
			default: 'transparent'
		},
		parentLoading: {
			type: Boolean,
			default: false
		},
		onlyPaymentMethodSelect: {
			type: Boolean,
			default: false
		},
		onlyCreditCard: {
			type: Boolean,
			default: false
		},
		buttonText: {
			type: String,
			default: 'Pay'
		}
	},
	PP_MAGENSA: PAYMENT_PROVIDER.MAGENSA,
	components: {
		CreditCardModalMagensa
	},

	data() {
		return {
			body: null
		}
	},

	computed: {
		...mapGetters('venue', ['caPaymentProvider']),
		isMagensa() {
			return this.caPaymentProvider === this.$options.PP_MAGENSA
		}
	},

	mounted() {
		this.setBodyStyles()
	},

	beforeDestroy() {
		this.removeBodyStyles()
	},

	methods: {
		...mapActions('ui', ['lockScroll', 'unlockScroll']),

		setBodyStyles() {
			this.lockScroll()
		},

		removeBodyStyles() {
			this.unlockScroll()
		}
	}
}
</script>
